import type { Timeout } from 'ahooks/lib/useRequest/src/types';
import { observableStoreOp } from './map';

export const globalRxTimer = {
  timer: null as Timeout | null,
  start() {
    globalRxTimer.stop();
    // wait 30s
    globalRxTimer.timer = setInterval(globalRxTimer.run, 1 * 30 * 1000);
  },
  run() {
    globalRxTimer.stop();
    const map = observableStoreOp.getMap();
    map.forEach((item, key) => {
      const observed = item.observed.valueOf();
      if (!observed) {
        observableStoreOp.deleteObs(key);
      }
    });
  },
  stop() {
    if (globalRxTimer.timer) {
      clearInterval(globalRxTimer.timer);
    }
  },
};

globalRxTimer.start();
